import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
	mode: "hash",
	 // mode: 'history',
	routes: [{
			path: '/',
			name: 'home',
			component: () =>
			import('@/view/main/home.vue'),
			// import("@/components/app/app_question_list.vue"),

			redirect: {
				// name: 'login' //  
				name: 'web_index' //login  
			},
			/** 首页子菜单  **/
			children: [{
					// 问答列表
					path: '/app/question/list',
					name: 'app_question_list',
					component: () =>
						import("@/components/app/app_question_list.vue"),
					meta: {
						title: "问答列表",
						url: '',
						index: "1",
						name: "问答列表"
					}
				},{
					// 用户列表
					path: '/app/user/list',
					name: 'user_list',
					component: () =>
						import("@/components/app/app_user_list.vue"),
					meta: {
						title: "用户列表",
						url: '',
						index: "2",
						name: "用户列表"
					}
				},
				
				{
					// 动态列表
					path: '/app/dynamic/list',
					name: 'dynamic_list',
					component: () =>
						import("@/components/app/app_dynamic_list.vue"),
					meta: {
						title: "动态列表",
						url: '',
						index: "3",
						name: "动态列表"
					}
				},
				{
					// 财务列表
					path: '/app/wallet/list',
					name: 'app_wallet_list',
					component: () =>
						import("@/components/app/app_wallet_list.vue"),
					meta: {
						title: "财务列表",
						url: '',
						index: "4",
						name: "财务列表"
					}
				},
				{
					// 专家列表
					path: '/app/experts/list',
					name: 'app_experts_list',
					component: () =>
						import("@/components/app/app_experts_list.vue"),
					meta: {
						title: "专家列表",
						url: '',
						index: "4",
						name: "专家列表"
					}
				},{
					// 专家审核列表
					path: '/app/experts/approve/list',
					name: 'app_experts_approve_list',
					component: () =>
						import("@/components/app/app_experts_approve_list.vue"),
					meta: {
						title: "专家审核列表",
						url: '',
						index: "4",
						name: "专家审核列表"
					}
				},{
					// 代理列表
					path: '/app/agent/list',
					name: 'app_agent_list',
					component: () =>
						import("@/components/app/app_agent_list.vue"),
					meta: {
						title: "代理列表",
						url: '',
						index: "4",
						name: "代理列表"
					}
				},{
					// 代理审批列表
					path: '/app/agent/approve/list',
					name: 'app_agent_approve_list',
					component: () =>
						import("@/components/app/app_agent_approve_list.vue"),
					meta: {
						title: "代理审批列表",
						url: '',
						index: "4",
						name: "代理审批列表"
					}
				},
				{
					path: '/app/certificate/list',
					name: 'certificate_list',
					component: () =>
						import("@/components/app/app_certificate_list.vue"),
					meta: {
						title: "凭证审核列表",
						url: '',
						index: "9",
						name: "凭证审核列表"
					}
				},

			],
		},

		/** 首页子菜单结束 **/

		{
			// 首页
			path: '/app',
			name: 'app_question_list2',
			component: () =>
				import("@/components/app/app.vue"),
			meta: {
				name: "主页"
			}
		},
		{
			// 注册页
			path: '/login',
			name: 'login',
			component: () =>
				import('@/view/main/login'),
			meta: {
				title: "律邦智库 - 登录",
				url: '',
				index: "1"
			}
		},

		{
			path: '/app/question/detail',
			name: 'app_question_details',
			component: app_question_details => require([
					'@/components/app/app_question_details.vue'
				],
				app_question_details),
			meta: {
				breadList: [{
					url: '',
					name: '问答详情'
				}]
			}
		},
		{
			path: '/app/dynamic/detail',
			name: 'app_dynamic_details',
			component: app_dynamic_details => require([
					'@/components/app/app_dynamic_details.vue'
				],
				app_dynamic_details),
			meta: {
				breadList: [{
					url: '',
					name: '动态详情'
				}]
			}
		},
		{
			path: '/app/agent/detail',
			name: 'app_agent_details',
			component: app_agent_details => require([
					'@/components/app/app_agent_details.vue'
				],
				app_agent_details),
			meta: {
				breadList: [{
					url: '',
					name: '代理详情'
				}]
			}
		},
		{
			path: '/app/agent/approve/detail',
			name: 'app_agent_approve_details',
			component: app_agent_details => require([
					'@/components/app/app_agent_approve_details.vue'
				],
				app_agent_details),
			meta: {
				breadList: [{
					url: '',
					name: '代理审批详情'
				}]
			}
		},
		
		{
			path: '/app/user/detail',
			name: 'app_user_details',
			component: app_user_details => require([
					'@/components/app/app_user_details.vue'
				],
				app_user_details),
			meta: {
				breadList: [{
					url: '',
					name: '专家详情'
				}]
			}
		},
		{
			path: '/app/user/approve/detail',
			name: 'app_user_approve_details',
			component: app_user_approve_details => require([
					'@/components/app/app_user_approve_details.vue'
				],
				app_user_approve_details),
			meta: {
				breadList: [{
					url: '',
					name: '专家审核详情'
				}]
			}
		},
		
		{
			path: '/app/wallet/detail',
			name: 'app_wallet_details',
			component: app_wallet_details => require([
					'@/components/app/app_wallet_details.vue'
				],
				app_wallet_details),
			meta: {
				breadList: [{
					url: '',
					name: '财务账单详情'
				}]
			}
		},
		{
			path: '/app/agent/add',
			name: 'addAgentForm',
			component: addAgentForm => require([
					'@/components/app/addAgentForm.vue'
				],
				addAgentForm),
			meta: {
				breadList: [{
					url: '',
					name: '代理申请'
				}]
			}
		},

		{
			path: '/invite',
			name: 'app_question_detail',
			component: app_question_detail => require([
					'@/components/app/app_question_detail.vue'
				],
				app_question_detail),
			meta: {
				breadList: [{
					url: '',
					name: '问答分享详情'
				}]
			}
		},
		{
			path: '/invite/android',
			name: 'app_question_detail2',
			component: app_question_detail2 => require([
					'@/components/app/app_question_detail2.vue'
				],
				app_question_detail2),
			meta: {
				breadList: [{
					url: '',
					name: 'android问答分享详情'
				}]
			}
		},
		{
			path: '/protocol',
			name: 'app_protocol',
			component: app_protocol => require([
					'@/components/app/app_protocol.vue'
				],
				app_protocol),

			meta: {
				breadList: [{
					url: 'app_protocol',
					name: '用户注册协议'
				}]
			}
		},
		{
			path: '/about',
			name: 'app_about',
			component: app_about => require([
					'@/components/app/app_about.vue'
				],
				app_about),

			meta: {
				breadList: [{
					url: 'app_about',
					name: '关于'
				}]
			}
		},
		// 官网宣传网页
		{
			path: '/web',
			name: 'web_index',
			component: web_index => require([
					'@/components/app/web_index.vue'
				],
				web_index),
		
			meta: {
				title: '律邦智库22',
				keywords:'lawband,律邦智库',
				description:'',
				breadList: [{
					url: 'web_index',
					name: '官网首页'
				}]
			}
		},
		// 官网专家网页
		{
			path: '/web/experts',
			name: 'web_experts',
			component: web_experts => require([
					'@/components/app/web_experts.vue'
				],
				web_experts),
		
			meta: {
				breadList: [{
					url: 'web_experts',
					name: '专家'
				}]
			}
		},
		// 官网合伙人网页
		{
			path: '/web/partner',
			name: 'web_partner',
			component: web_partner => require([
					'@/components/app/web_partner.vue'
				],
				web_partner),
		
			meta: {
				breadList: [{
					url: 'web_partner',
					name: '合伙人'
				}]
			}
		},
		// 官网社会价值网页
		{
			path: '/web/social',
			name: 'web_social',
			component: web_social => require([
					'@/components/app/web_social.vue'
				],
				web_social),
		
			meta: {
				breadList: [{
					url: 'web_social',
					name: '社会价值'
				}]
			}
		},
		
		
		
		// 官网app下载网页
		{
			path: '/web/download',
			name: 'web_app_download',
			component: web_app_download => require([
					'@/components/app/web_app_download.vue'
				],
				web_app_download),
		
			meta: {
				breadList: [{
					url: 'web_app_download',
					name: 'app下载'
				}]
			}
		},
		// 官网代理商网页
		{
			path: '/web/agent',
			name: 'web_agent',
			component: web_agent => require([
					'@/components/app/web_agent.vue'
				],
				web_agent),
		
			meta: {
				breadList: [{
					url: 'web_agent',
					name: '代理商'
				}]
			}
		},
		// 官网专家展示网页
		{
			path: '/web/user',
			name: 'web_user',
			component: web_user => require([
					'@/components/app/web_user.vue'
				],
				web_user),
		
			meta: {
				breadList: [{
					url: 'web_user',
					name: '用户'
				}]
			}
		},
		// appy隐私协议
		{
			path: '/privacy',
			name: 'privacy',
			component: app_privacy => require([
					'@/components/app/app_privacy.vue'
				],
				app_privacy),
		
			meta: {
				breadList: [{
					url: 'app_privacy',
					name: '隐私协议'
				}]
			}
		},

	]
})

// router.beforeEach(function(to, from, next) {
// 	if (!localStorage.getItem('loginInfo')) {
// 		console.log(localStorage.getItem('loginInfo'))
// 		console.log(!localStorage.getItem('loginInfo'))
// 		if (to.path !== '/login') {
// 			return next('/login')
// 		}
// 	}
// 	// document.title = to.meta.title
// 	next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js